import React, { useState, useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import './Alarmas.css';

function Alarmas(props) {
    var getBrowserWidth = function () {

        if (window.innerWidth < 1023) {
            return "xs";

        }
    };
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    const [filtrarActivas, setFiltrarActivas] = useState(false);
    var [textoBotonActivas, setTextoBotonActivas] = useState('Mostrar solo activas');
    var [ALARMAS, setALARMAS] = useState([]);
    var [activas, setActivas] = useState(0);
    var [filas, setFilas] = useState([]);
    const variablesAPedir = "id,solarFarm,idDevice,name,alarmId,alarm,severity,active,description,startDate,endDate";

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setALARMAS(await dataINV.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setALARMAS(await dataINV.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    function botonFiltrarActivas() {
        if (textoBotonActivas === 'Mostrar solo activas') {
            setTextoBotonActivas('Mostrar todo');
            setFiltrarActivas(true);
        } else {
            setTextoBotonActivas('Mostrar solo activas');
            setFiltrarActivas(false);
        }
    };
    /*Tamaño para las columnas de la tabla y cuatas filas de alarmas queremos*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamColumPeque, tamañoDescri, tamañoFechas;
    var filas_alarmas;

    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 9;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = (pixelesRestantes / columnasTabla) - 0.2;
        tamColumPeque = tamañoColum / 2;

        tamañoDescri = tamañoColum + tamañoColum;
        tamañoFechas = tamañoColum + (tamColumPeque / 2);
        filas_alarmas = 13;
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        tamañoColum = 100;
        tamColumPeque = 90;
        tamañoDescri = 420;
        tamañoFechas = 160;
        filas_alarmas = 10;
    }
    /**Controlar el reajuste de tamaño de pantalla */
    window.addEventListener("resize", () => {
        if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
            //Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla 
            anchoPantalla = window.screen.width;
            columnasTabla = 9;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = (pixelesRestantes / columnasTabla) - 0.2;
            tamColumPeque = tamañoColum / 2;
            tamañoDescri = tamañoColum + tamañoColum;
            tamañoFechas = tamañoColum + (tamColumPeque / 2);
            filas_alarmas = 14;
        } else {
            //Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla 
            tamañoColum = 100;
            tamColumPeque = 90;
            tamañoDescri = 420;
            tamañoFechas = 160;
            filas_alarmas = 10;
        }
    });
    var mobil = getBrowserWidth();
    var columnas;
    columnas = [{ field: 'id', headerName: 'ID', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', hide: true, cellClassName: 'cell-solarfarm-id' },
    { field: 'solarFarm', headerName: 'SolarFarm', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'nombre', headerName: 'Nombre', width: tamañoColum, headerClassName: 'super-app-theme--header', cellClassName: 'cell-solarfarm-nombre', headerAlign: 'center' },
    { field: 'alarma', headerName: 'Alarma', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-alarma' },
    { field: 'severidad', headerName: 'Severidad', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-severidad' },
    { field: 'descripcion', headerName: 'Descripción', width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-descripcion' },
    { field: 'estado', headerName: 'Estado', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-estado' },
    { field: 'inicio', headerName: 'Fecha Inicio', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-inicio' },
    { field: 'fin', headerName: 'Fecha Fin', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm-fin' }];
    useEffect(() => {
        var array = [];
        var activas_aux = 0;
        ALARMAS.map((datoINV) => {
            const { id, solarFarm,idDevice, name, alarmId,alarm, severity, active, description, startDate, endDate } = datoINV;
            var auxState;
            var auxalarma;
            if (active === true) {
                auxState = "Activa";
                activas_aux++;
            } else {
                auxState = "Inactiva";
            }

            if(alarmId != null){
                auxalarma = alarmId;
            }else if(alarm != null && idDevice === 5 ) {
                auxalarma = alarm;
            }else{
                auxalarma = "";
            }
            array.push({ id: id, solarFarm: solarFarm, nombre: name, alarma: auxalarma, severidad: severity, descripcion: description, estado: auxState, inicio: startDate, fin: endDate });
        })
        if (filtrarActivas === true) {
            array = array.filter(a => { return a.estado === "Activa" });
        }
        setFilas(array.reverse()); //Queremos que las mas nuevas aparezcan antes
        setActivas(activas_aux);
    }, [ALARMAS, filtrarActivas]);
    if (mobil === 'xs') {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: "0%", padding: "0%" }}>
                                <div className='col-auto' id='div-table-alarms'>
                                    <DataGridPro
                                        sx={{
                                            width: '100%',
                                            align: 'center',
                                            ".MuiDataGrid-columnHeaders": { overflowX: 'scroll' },
                                            ".MuiDataGrid-row": { display: 'block', width: '100% !important', paddingLeft: '0%', marginLeft: '0%' },
                                            ".MuiDataGrid-virtualScrollerContent": { width: 'auto !important' },
                                            ".MuiDataGrid-virtualScrollerRenderZone": { width: ' -webkit-fill-available' },
                                            ".MuiDataGrid-main": { overflow: 'none', },
                                            ".MuiDataGrid-cell": { width: 'fit-content', border: 'none', position: 'relative', paddingLeft: '30%', marginTop: '.5%'},
                                            ".MuiDataGrid-virtualScroller": { marginTop: '56px !important' },
                                            '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                            '& .super-app-theme--Activa': { color: 'red' },
                                            '& .super-app-theme--Inactiva': { color: 'green' }
                                            
                                        }}
                                        rows={filas} columns={columnas} pagination pageSize={5} autoHeight={true} /*checkboxSelection*/
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Alarmas" } } }}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick disableColumnResize='true'
                                        getRowHeight={() => 'auto'}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: "0%", padding: "0%" }}>
                                <div className='col-auto' id='div-table-alarms'>
                                    <DataGridPro
                                        sx={{
                                            width: '100%',
                                            '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                            '& .super-app-theme--Activa': { color: 'red' },
                                            '& .super-app-theme--Inactiva': { color: 'green' },
                                        }}
                                        rows={filas} columns={columnas} pagination pageSize={filas_alarmas} autoHeight={true} /*checkboxSelection*/
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Alarmas" } } }}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Alarmas